/**
 * CExoLocStringLanguage enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file CExoLocStringLanguage.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum CExoLocStringLanguage {
  'English' = 0,
  'French' = 1,
  'German' = 2,
  'Italian' = 3,
  'Spanish' = 4,
  'Polish' = 5,
  'Korean' = 128,
  'Chinese Traditional' = 129,
  'Chinese Simplified' = 130,
  'Japanese' = 131
};